<template>
  <div id="main" :class="{ mask: !isDeveloper }">
    <!-- 页面切换 -->
    <div id="tab">
      <p
        class="btn-label"
        :class="{ 'p-chosen': activeLabel == index }"
        v-for="(label, index) in labelArr"
        :key="index"
        @click="changeLabel(index)"
      >
        <!-- @click="activeLabel = index" -->
        {{ label }}
      </p>
    </div>
    <!-- 分页 - 数据总览 -->
    <div id="overview" v-show="!activeLabel">
      <div class="card-content">
        <div class="card-title">
          <div class="title-help">
            <p class="name">数据趋势总览</p>
            <span class="help">
              <div class="help-tip">
                <HelpTip></HelpTip>
              </div>
              <!-- <div class="data-filter">
                <span class="desc">日期选择： </span>
                <div class="data-select">
                  <el-select
                    v-model="dayNum"
                    placeholder="请选择"
                    size="small"
                    @change="changeDay"
                  >
                    <el-option
                      v-for="item in dayOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div> -->
              <div class="week-filter">
                <span class="desc">统计周期：</span>
                {{ countTime }}
              </div>
            </span>
          </div>
          <!-- <p class="day-title">过去{{ dayNum }}天累计数据</p> -->
        </div>
        <div class="complex-wrap" v-loading="loadingCharts">
          <!--作品数据-->
          <div class="card-box">
            <div class="title">作品数据</div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in productData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index }"
                @click.native="changeCard(index)"
              >
              </cpn-cards>
            </div>
          </div>
          <div class="card-box">
            <div class="title">用户数据</div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in membersData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index + 2 }"
                @click.native="changeCard(index + 2)"
              >
              </cpn-cards>
            </div>
          </div>
          <div class="card-box">
            <div class="title">互动数据</div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in overviewData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index + 6 }"
                @click.native="changeCard(index + 6)"
              >
              </cpn-cards>
            </div>
          </div>
          <div class="card-box">
            <div class="title">
              <!-- 收入数据 -->
              <span class="help-tip">
                <!-- <template slot="header"> -->
                <el-tooltip placement="right">
                  <span>
                    收入数据
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    认证成为工作室成员后归属于工作室的地图不展示收入数据
                  </p>
                </el-tooltip>
                <!-- </template> -->
              </span>
            </div>
            <div id="card">
              <cpn-cards
                v-for="(item, index) in incomeData"
                :key="index"
                :data="item"
                class="card-wrap"
                :class="{ 'active-card': activeCard == index + 10 }"
                @click.native="changeCard(index + 10)"
              >
              </cpn-cards>
            </div>
          </div>
          <div id="charts">
            <!-- <p class="charts-title">过去{{ dayNum }}天{{ getChartTitle }}</p> -->
            <p class="charts-title">自然月{{ getChartTitle }}</p>
            <ve-line
              :extend="chartExtend"
              v-if="!isShowChartDefault"
              :data="chartData"
              :legend-visible="false"
            ></ve-line>
            <div class="img-no-data" v-else>
              <img src="../../assets/images/img_map_no_data.png" />
              <p>您暂时还没有数据呢~</p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div id="resource-data" v-if="isDeveloper">
        <p class="map-title">地图数据</p>
        <div class="map-card-list" v-loading="loadingList">
          <template v-if="!isShowListDefault">
            <div>
              <cpn-resourceList
                v-for="(item, index) in tableData"
                :key="index"
                :data="item"
                v-show="index < 5"
              ></cpn-resourceList>
            </div>
            <span class="btn-more-map" v-if="isDeveloper" @click="moreClick"
              >查看更多地图</span
            >
          </template>
          <div class="img-map-no-data" v-else>
            <img src="../../assets/images/img_map_no_data.png" />
            <p>您暂时还没有数据呢~</p>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 分页 - 作品列表 -->

    <WorkList v-if="activeLabel"></WorkList>
    <!-- 遮罩层内容 -->
    <Masking
      v-if="!isDeveloper"
      :height="946"
      :left="50"
      :mapType="true"
    ></Masking>
  </div>
</template>

<script>
import HelpTip from '@/components/HelpTip';
import WorkList from './workList';
import cpnCards from './components/cpn-cards.vue';
// import cpnResourceList from './components/cpn-resourceList.vue';
import { getMapAllOverview, getMapList, getMotivate } from '@/api/charts';
import Masking from '@/components/Masking';
import { mapState } from 'vuex';
import { chartExtend } from './components/chartsStyle';
// import {reportData} from '@/main.js'
export default {
  components: {
    HelpTip,
    WorkList,
    Masking,
    'cpn-cards': cpnCards,
    // 'cpn-resourceList': cpnResourceList
  },
  data() {
    return {
      isDeveloper: false,
      labelArr: ['数据总览', '作品列表'],
      activeLabel: 0,
      overviewData: [],
      productData: [],
      incomeData: [],
      IncentData: [],
      membersData: [],
      single: {},
      numData: [],
      tableData: [],
      dayNum: 30,
      dayOptions: [
        { value: 1, label: '昨日' },
        { value: 7, label: '近七日' },
        { value: 30, label: '近30日' },
      ],
      chartData: {
        columns: ['日期', '数据'],
        rows: [],
      },
      activeCard: 0,
      yesterday: '',
      startStaicDate: '',
      endStaticDate: '',
      lastWeekday: '',
      lastMonthday: '',
      chartsTitle: '',
      overviewList: [], // 存储接口概览数据
      monvaViewList: [], //存储激励数据
      loadingCharts: false,
      loadingList: false,
      isShowChartDefault: false,
      isShowListDefault: false,
      chartExtend: chartExtend,
      dateList: [],
      // countTime: '2021.10.25'
    };
  },

  beforeDestroy() {
    this.$store.commit('SET_BACKLABEL', 0);
  },
  computed: {
    ...mapState(['userInfo']),
    getChartTitle() {
      let title1 = '';
      switch (this.activeCard) {
        case 0:
          title1 = '作品浏览总次数变化';
          break;
        case 1:
          title1 = '作品下载总次数变化';
          break;
        case 2:
          title1 = '游戏总次数变化';
          break;
        case 3:
          title1 = '游戏总时长（分钟）变化';
          break;
        case 4:
          title1 = '人均游玩时长（分钟）变化';
          break;
        case 5:
          title1 = '游戏人数变化';
          break;
        case 6:
          title1 = '评论数变化';
          break;
        case 7:
          title1 = '投块数变化';
          break;
        case 8:
          title1 = '收藏数变化';
          break;
        case 9:
          title1 = '点赞数变化';
          break;
        case 10:
          title1 = '广告总收入变化';
          break;
        case 11:
          title1 = '迷你豆数量变化';
          break;
        case 12:
          title1 = '迷你点数量变化';
          break;
        case 13:
          title1 = '贡献点数量变化';
          break;
        // case 12:
        //   title1 = '广告总收入变化';
        //   break;
        // case 13:
        //   title1 = '迷你豆数量变化';
        //   break;
        // case 14:
        //   title1 = '迷你点数量变化';
        //   break;
        // case 15:
        //   title1 = '贡献点数量变化';
        //   break;
        // case 16:
        //   title1 = '其他收入变化';
        //   break;
        default:
          break;
      }
      return title1;
    },
    countTime() {
      let time = '';
      // if (this.dayNum === 1) {
      //   time = this.yesterday;
      // } else if (this.dayNum === 7) {
      //   time = this.lastWeekday + '-' + this.yesterday;
      // } else {
      //   time = this.lastMonthday + '-' + this.yesterday;
      // }
      time = this.startStaicDate + '-' + this.endStaicDate;
      return time;
    },
    ...mapState(['developerInfo', 'backLabel']),
  },
  created() {
    this.getMotivateData();
    this.Report('view', 'MapDataPage');
  },
  mounted() {
    /**判断当前日期是否小于7 */
    if (new Date().getDate() < 7) {
      this.getWeekDateData();
    } else {
      this.getNatureMonthDay();
      //  this.getWeekDateData();
    }
    // if (this.dayNum === 30) {
    //   //  this.getSectionDateData();
    //   this.getNatureMonthDay();
    // } else if (this.dayNum === 7) {
    //   this.getWeekDateData();
    // } else {
    //   this.getWeekDateData();
    // }
    this.init();
  },
  methods: {
    moreClick() {
      this.activeLabel = 1;
      this.moreMapClick();
    },
    //查看更多地图点击埋点
    moreMapClick() {
      this.$log('more_map_click', 85412, { v7: 1 });
    },
    init() {
      if (this.developerInfo.state == 0 || this.developerInfo.state == 3) {
        this.productData = [
          {
            title: '作品浏览总次数',
            prop: 'browse',
            value: 500,
            yes: 1000,
          },
          // {
          //   title: '作品浏览总人数',
          //   prop: 'browse',
          //   value: 500,
          //   yes: 1000
          // },
          {
            title: '作品下载总次数',
            prop: 'download',
            value: 500,
            yes: 1000,
          },
          // {
          //   title: '作品下载总人数',
          //   prop: 'download',
          //   value: 500,
          //   yes: 1000
          // }
        ];
        this.membersData = [
          // {
          //   title: '游戏总人数',
          //   prop: 'browse',
          //   value: 500,
          //   yes: 1000
          // },
          {
            title: '游戏总次数',
            prop: 'play_count',
            value: 500,
            yes: 1000,
          },
          {
            title: '游戏总时长(分钟)',
            prop: 'play_count',
            value: 500,
            yes: 1000,
          },
          {
            title: '次均游玩时长(分钟)',
            prop: 'play_time',
            value: 500,
            yes: 1000,
          },
          {
            title: '游戏人数',
            prop: 'player',
            value: 500,
            yes: 1000,
          },
          // {
          //   title: '新增用户数',
          //   prop: 'comment',
          //   value: 500,
          //   yes: 1000
          // }
        ];
        this.overviewData = [
          {
            title: '评论数',
            prop: 'comment',
            value: 500,
            yes: 1000,
          },
          {
            title: '投块数',
            prop: 'block',
            value: 500,
            yes: 1000,
          },
          {
            title: '收藏数',
            prop: 'collect',
            value: 500,
            yes: 1000,
          },
          {
            title: '点赞数',
            prop: 'praise',
            value: 500,
            yes: 1000,
          },
        ];
        this.incomeData = [
          {
            title: '广告总收入',
            prop: 'block',
            value: 500,
            yes: 1000,
          },
          {
            title: '迷你豆数量',
            prop: 'block',
            value: 500,
            yes: 1000,
          },
          {
            title: '迷你点数量',
            prop: 'block',
            value: 500,
            yes: 1000,
          },
          {
            title: '贡献点数量',
            prop: 'block',
            value: 500,
            yes: 1000,
          },
          // {
          //   title: '其他收入',
          //   prop: 'block',
          //   value: 500,
          //   yes: 1000
          // }
        ];
        this.chartsTitle = '过去1日下载数变化';
        this.chartData = {
          columns: ['日期', '数据'],
          rows: [
            { 日期: '2021-03-17', 数据: 35 },
            { 日期: '2021-03-18', 数据: 65 },
            { 日期: '2021-03-19', 数据: 25 },
            { 日期: '2021-03-20', 数据: 85 },
            { 日期: '2021-03-21', 数据: 25 },
            { 日期: '2021-03-22', 数据: 10 },
            { 日期: '2021-03-23', 数据: 25 },
            { 日期: '2021-03-24', 数据: 85 },
            { 日期: '2021-03-25', 数据: 66 },
            { 日期: '2021-03-27', 数据: 75 },
            { 日期: '2021-03-28', 数据: 19 },
            { 日期: '2021-03-29', 数据: 24 },
            { 日期: '2021-03-30', 数据: 89 },
          ],
        };
      } else {
        this.isDeveloper = true;
        //  this.fetchMapOverview();
        this.getYesterday();
        // this.fetchMapList();
      }
      //数据总览埋点
      if (!this.activeLabel) {
        this.dataShow();
      }
      if (this.backLabel == 1) {
        this.activeLabel = this.backLabel;
      } else {
        //this.$store.commit('SET_BACKLABEL', 0);
        this.activeLabel = 0;
      }
    },
    //切换查看数据
    changeLabel(index) {
      this.activeLabel = index;
      if (!this.activeLabel) {
        this.dataShow();
      } else {
        this.proListShow();
      }
    },
    //数据总览页展示埋点
    dataShow() {
      this.$log('data_overview_show', 85407, { v7: 1 });
    },
    //作品列表展示埋点
    proListShow() {
      this.$log('product_list_show', 85413, { v7: 1 });
    },
    //切换时间
    changeDay() {
      //  this.fetchMapOverview();
      if (this.dayNum === 30) {
        this.getSectionDateData();
        //  this.getNatureMonthDay();
        this.getChartsData();
      } else if (this.dayNum === 7) {
        this.getWeekDateData();
        this.getChartsData();
      } else {
        this.getChartsData();
        this.getWeekDateData();
      }
    },
    //获取近7日的年月日，其他默认数据为0
    getWeekDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 7);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          ad: 0,
          minibean: 0,
          minipoint: 0,
          other: 0,
          contribution: 0,
          play_avg_time: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },

    /**
     * 获取近30天的年月日，其他数据默认为0
     */
    getSectionDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 30);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          ad: 0,
          minibean: 0,
          minipoint: 0,
          other: 0,
          contribution: 0,
          play_avg_time: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    /**
     * 获取自然月的年月日，其他默认数据为0
     * 当前日期小于1周展示近三天的数据
     **/
    getNatureMonthDay() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - new Date().getDate() + 1);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          ad: 0,
          minibean: 0,
          minipoint: 0,
          other: 0,
          contribution: 0,
          play_avg_time: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    // 获取卡片数据-接口
    async fetchMapOverview() {
      this.loadingCharts = true;
      try {
        const res = await getMapAllOverview();
        this.overviewList =
          res.data && res.data.list && res.data.list.length
            ? res.data.list
            : [];
        //加上激励数据
        if (this.monvaViewList.length) {
          //判断数据是否为空
          if (!this.overviewList.length) {
            this.overviewList.push(this.monvaViewList[0]);
            for (let j = 1; j < this.monvaViewList.length; j++) {
              for (let i = 0; i < this.overviewList.length; i++) {
                if (this.overviewList[i].date == this.monvaViewList[j].date) {
                  this.overviewList[i].download =
                    (this.monvaViewList[j].download | 0) +
                    (this.overviewList[i].download | 0);
                  this.overviewList[i].play_avg_time =
                    (this.monvaViewList[j].play_avg_time | 0) +
                    (this.overviewList[i].play_avg_time | 0);
                  this.overviewList[i].play_time =
                    (this.monvaViewList[j].play_time | 0) +
                    (this.overviewList[i].play_time | 0);
                  this.overviewList[i].play_count =
                    (this.monvaViewList[j].play_count | 0) +
                    (this.overviewList[i].play_count | 0);
                  this.overviewList[i].player =
                    (this.monvaViewList[j].player | 0) +
                    (this.overviewList[i].player | 0);
                  this.overviewList[i].browse =
                    (this.monvaViewList[j].browse | 0) +
                    (this.overviewList[i].browse | 0);
                  break;
                } else {
                  this.overviewList.push(this.monvaViewList[j]);
                  break;
                }
              }
            }
          } else {
            for (let j = 0; j < this.monvaViewList.length; j++) {
              for (let i = 0; i < this.overviewList.length; i++) {
                if (this.overviewList[i].date == this.monvaViewList[j].date) {
                  this.overviewList[i].download =
                    (this.monvaViewList[j].download | 0) +
                    (this.overviewList[i].download | 0);
                  this.overviewList[i].play_avg_time =
                    (this.monvaViewList[j].play_avg_time | 0) +
                    (this.overviewList[i].play_avg_time | 0);
                  this.overviewList[i].play_time =
                    (this.monvaViewList[j].play_time | 0) +
                    (this.overviewList[i].play_time | 0);
                  this.overviewList[i].play_count =
                    (this.monvaViewList[j].play_count | 0) +
                    (this.overviewList[i].play_count | 0);
                  this.overviewList[i].player =
                    (this.monvaViewList[j].player | 0) +
                    (this.overviewList[i].player | 0);
                  this.overviewList[i].browse =
                    (this.monvaViewList[j].browse | 0) +
                    (this.overviewList[i].browse | 0);
                  break;
                } else {
                  this.overviewList.push(this.monvaViewList[j]);
                  break;
                }
              }
            }
          }
        }
        this.sumScreening();
        this.getChartsData();
        this.loadingCharts = false;
      } catch (error) {
        this.loadingCharts = false;
        console.log(error);
      }
    },
    // 获取前5地图数据
    async fetchMapList() {
      this.loadingList = true;
      let data = {
        sort_type: 1,
        page: 1,
        page_size: 5,
      };
      try {
        const res = await getMapList(data);
        this.tableData = res.data.list;
        this.loadingList = false;
        if (this.tableData.length) {
          this.isShowListDefault = false;
        } else {
          this.isShowListDefault = true;
        }
      } catch (error) {
        this.loadingList = false;
        console.log(error);
      }
    },
    //获取全地图激励数据
    async getMotivateData() {
      const time = parseInt(new Date().getTime() / 1000);
      let data = {
        time: time,
        range: 1,
      };
      const res = await getMotivate(data);
      if (res.data.ret === 0) {
        this.single = res.data.msg.all;
        let obj = res.data.msg.single; //将激励数据存进数组
        for (let key in obj) {
          let time = new Date(obj[key].time * 1000);
          const year = time.getFullYear();
          const month = (time.getMonth() + 1).toString().padStart(2, '0');
          const day = time.getDate().toString().padStart(2, '0');
          this.monvaViewList.push({
            date: year + '-' + month + '-' + day,
            play_avg_time: obj[key].play_avg_time | 0,
            collect: 0,
            block: 0,
            ad: 0,
            player: obj[key].player | 0,
            minibean: 0,
            minipoint: 0,
            other: 0,
            contribution: 0,
            browse: obj[key].browse | 0,
            comment: 0,
            praise: 0,
            download: obj[key].download | 0,
            play_count: obj[key].play_count | 0,
            play_time: obj[key].play_time | 0,
          });
        }
      }
      this.fetchMapOverview();
    },
    // 获取 '2020-04-18'格式昨日日期
    getYesterday() {
      let day = new Date();
      let weekDay = new Date();
      let monthDay = new Date();
      let endDateDay = new Date();
      let lastMonthDateDay = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      weekDay.setTime(weekDay.getTime() - 7 * 24 * 60 * 60 * 1000);
      monthDay.setTime(monthDay.getTime() - 30 * 24 * 60 * 60 * 1000);
      endDateDay.setTime(
        endDateDay.getTime() -
          endDateDay.getDate() * 24 * 60 * 60 * 1000 +
          24 * 60 * 60 * 1000,
      );
      lastMonthDateDay.setTime(
        lastMonthDateDay.getTime() -
          lastMonthDateDay.getDate() * 24 * 60 * 60 * 1000,
      );
      let year = day.getFullYear();
      let month =
        String(day.getMonth() + 1).length < 2
          ? '0' + (day.getMonth() + 1)
          : day.getMonth() + 1;
      let month1 =
        String(monthDay.getMonth() + 1).length < 2
          ? '0' + (monthDay.getMonth() + 1)
          : monthDay.getMonth() + 1;
      let yesMonth =
        String(monthDay.getMonth() + 1).length < 2
          ? '0' + (monthDay.getMonth() + 1)
          : monthDay.getMonth() + 1;
      let date =
        String(day.getDate()).length < 2 ? '0' + day.getDate() : day.getDate();
      let date1 =
        String(weekDay.getDate()).length < 2
          ? '0' + weekDay.getDate()
          : weekDay.getDate();
      let date2 =
        String(monthDay.getDate()).length < 2
          ? '0' + monthDay.getDate()
          : monthDay.getDate();
      let date3 =
        String(lastMonthDateDay.getDate()).length < 2
          ? '0' + lastMonthDateDay.getDate()
          : lastMonthDateDay.getDate();
      let date4 =
        String(endDateDay.getDate()).length < 2
          ? '0' + endDateDay.getDate()
          : endDateDay.getDate();
      let date5 = '01';
      this.yesterday = year + '.' + month + '.' + date;
      this.yesterday1 = year + '-' + month + '-' + date;
      this.lastWeekday = year + '.' + month + '.' + date1; //一周前
      this.lastMonthday = year + '.' + month1 + '.' + date2; //一个月前
      //判断当前日期是否是1号，1号则统计周期为上个月
      if (new Date().getDate() === 1) {
        this.startStaicDate = year + '.' + yesMonth + '.' + date5;
        this.endStaicDate = year + '.' + yesMonth + '.' + date3;
      } else {
        this.startStaicDate = year + '.' + month + '.' + date4;
        this.endStaicDate = year + '.' + month + '.' + date;
      }
    },
    // 求和/筛选昨日数据
    sumScreening() {
      //下载数
      let downloadSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.download);
      }, 0);
      //downloadSum = downloadSum + (this.single.download | 0);
      //浏览数
      let browseSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.browse);
      }, 0);
      //游玩次数
      let playCountSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.play_count);
      }, 0);
      //playCountSum = playCountSum + (this.single.play_count | 0);
      //游玩总时间
      let playTimeSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.play_time);
      }, 0);
      //playTimeSum = playTimeSum + (this.single.play_time | 0);
      //人均游玩时长
      // let playAvgTimeSum = this.overviewList.reduce((sum, current) => {
      //   return sum + Number(current.play_avg_time);
      // }, 0);
      let playAvgTimeSum;
      if (playTimeSum) {
        playAvgTimeSum = playTimeSum / playCountSum;
      } else {
        playAvgTimeSum = 0;
      }
      // playAvgTimeSum = playAvgTimeSum + (this.single.play_avg_time | 0);
      //广告总收入
      let adSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.ad);
      }, 0);
      //点赞数
      // let praiseSum = this.overviewList.reduce((sum, current) => {
      //   return sum + Number(current.praise);
      // }, 0);
      //迷你豆
      let minibeanSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.minibean);
      }, 0);
      //迷你点
      let minipointSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.minipoint);
      }, 0);
      //其他收入
      // let otherSum = this.overviewList.reduce((sum, current) => {
      //   return sum + Number(current.other);
      // }, 0);
      //评论数
      let commentSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.comment);
      }, 0);
      //投块数
      let blockSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.block);
      }, 0);
      //收藏数
      let collectSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.collect);
      }, 0);
      //点赞数
      let praiseSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.praise);
      }, 0);
      //collectSum = collectSum + (this.single.collect | 0);
      //贡献点
      let contributionSum = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.contribution);
      }, 0);
      //游戏总人数
      let Player = this.overviewList.reduce((sum, current) => {
        return sum + Number(current.player);
      }, 0);
      let yesData = this.overviewList.find(n => {
        return n.date == this.yesterday1;
      });

      let yesOjb = yesData ? yesData : {};
      this.productData = [
        {
          title: '作品浏览总次数',
          prop: 'browse',
          value: browseSum,
          yes: yesOjb.browse | 0,
        },
        // {
        //   title: '作品浏览总人数',
        //   prop: 'browse',
        //   value: browseSum,
        //   yes: yesOjb.browse | 0
        // },
        {
          title: '作品下载总次数',
          prop: 'download',
          value: downloadSum,
          yes: yesOjb.download | 0,
        },
        // {
        //   title: '作品下载总人数',
        //   prop: 'download',
        //   value: downloadSum,
        //   yes: yesOjb.download | 0
        // }
      ];
      this.membersData = [
        {
          title: '游戏总次数',
          prop: 'play_count',
          value: playCountSum,
          yes: yesOjb.play_count | 0,
        },
        {
          title: '游戏总时长(分钟)',
          prop: 'play_time',
          value: playTimeSum / 60,
          yes: (yesOjb.play_time | 0) / 60,
        },
        {
          title: '次均游玩时长(分钟)',
          prop: 'play_avg_time',
          value: playAvgTimeSum / 60,
          yes: (yesOjb.play_avg_time | 0) / 60,
        },
        {
          title: '游戏人数',
          prop: 'player',
          value: Player,
          yes: yesOjb.player | 0,
        },
        // {
        //   title: '新增用户数',
        //   prop: 'comment',
        //   value: commentSum,
        //   yes: yesOjb.comment | 0
        // }
      ];
      this.overviewData = [
        {
          title: '评论数',
          prop: 'comment',
          value: commentSum,
          yes: yesOjb.comment | 0,
        },
        {
          title: '投块数',
          prop: 'block',
          value: blockSum,
          yes: yesOjb.block | 0,
        },
        {
          title: '收藏数',
          prop: 'collect',
          value: collectSum,
          yes: yesOjb.collect | 0,
        },
        {
          title: '点赞数',
          prop: 'praise',
          value: praiseSum,
          yes: yesOjb.praise | 0,
        },
      ];
      this.incomeData = [
        {
          title: '广告总收入',
          prop: 'ad',
          value: adSum,
          yes: yesOjb.ad | 0,
        },
        {
          title: '迷你豆数量',
          prop: 'minibean',
          value: minibeanSum,
          yes: yesOjb.minibean | 0,
        },
        {
          title: '迷你点数量',
          prop: 'minipoint',
          value: minipointSum,
          yes: yesOjb.minipoint | 0,
        },
        {
          title: '贡献点数量',
          prop: 'contribution',
          value: contributionSum,
          yes: yesOjb.contribution | 0,
        },
        // {
        //   title: '其他收入',
        //   prop: 'other',
        //   value: otherSum,
        //   yes: yesOjb.other | 0
        // }
      ];
      //合并多个数组
      this.numData = this.productData
        .concat(this.membersData)
        .concat(this.overviewData)
        .concat(this.incomeData);
    },
    // 计算图表数据
    getChartsData() {
      this.chartData.rows = [];
      // if (this.overviewData[this.activeCard].value != 0) {
      // this.isShowChartDefault = false;
      this.chartsTitle = this.numData[this.activeCard].title;
      // if (this.activeCard <= 3) {
      //   this.chartsTitle = this.productData[this.activeCard].title;
      // } else if (this.activeCard <= 8) {
      //   this.chartsTitle = this.membersData[this.activeCard - 4].title;
      // } else if (this.activeCard <= 11) {
      //   this.chartsTitle = this.overviewData[this.activeCard - 9].title;
      // } else {
      //   this.chartsTitle = this.incomeData[this.activeCard - 12].title;
      // }
      this.dateList.forEach(date => {
        this.overviewList.forEach(item => {
          if (date.date == item.date) {
            date = item;
          }
        });
        const _prop = this.numData[this.activeCard].prop;
        this.chartData.rows.push({
          日期: date.date,
          数据:
            _prop == 'play_time' || _prop == 'play_avg_time'
              ? Number(date[_prop] / 60).toFixed(2)
              : date[_prop],
        });
      });
    },
    // 切换卡片
    changeCard(index) {
      this.activeCard = index;
      this.getChartsData();
      this.moduleClick(index);
    },
    //数据模块点击埋点
    moduleClick(index) {
      this.$log('data_module_show', 85410, { v7: 1, v8: index + 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

#main {
  display: flex;
  flex-flow: column;
  width: 100%;
  min-height: 100%;
  background-color: white;
  border-radius: 8px;
  //padding: 20px 33px 40px 33px;
  padding: 20px 33px 40px 33px;
}

#tab {
  margin-bottom: 18px;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  .btn-label {
    font-size: 20px;
    color: #595959;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .btn-label:nth-child(1) {
    margin-right: 32px;
  }

  .p-chosen {
    border-bottom: 4px solid $--color-primary;
    cursor: initial;
    position: relative;
    &:before {
      display: block;
      content: '';
      width: 0;
      border-width: 4px;
      border-style: solid;
      border-color: transparent transparent $--color-primary transparent;
      position: absolute;
      left: 50%;
      margin-left: -2px;
      bottom: 0;
    }
  }
}

#card {
  display: flex;
  justify-content: flex-start;
  //justify-content: space-between;
  flex-wrap: wrap;
  cursor: pointer;
  .chosen {
    border: 4px solid #bbb;
    background-color: #fbeded;
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      right: -4px;
      width: 0;
      height: 0;
      border: 15px solid;
      border-left-color: transparent;
      border-right-color: #bbb;
      border-top-color: transparent;
      border-bottom-color: #bbb;
    }
  }
}

#charts {
  min-height: 200px;
  .charts-title {
    font-size: 14px;
    color: #8c8c8c;
  }
}

#resource-data {
  display: flex;
  flex-flow: column;
  & > div {
    display: flex;
  }
  .map-title {
    font-size: 24px;
    margin-bottom: 22px;
  }
  .map-card-list {
    display: flex;
    flex-direction: column;
  }
}

#overview {
  .card-content {
    margin-bottom: 30px;
    .card-title {
      margin-bottom: 16px;
      .title-help {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        .name {
          font-size: 24px;
          color: #262626;
        }
        .help {
          .help-tip {
            display: flex;
            justify-content: flex-end;
          }
          .data-filter {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 8px;
            .desc {
              color: #262626;
              margin-right: 2px;
            }
            .data-select {
              width: 86px;
              height: 36px;
              ::v-deep .el-input.el-input--small.el-input--suffix {
                border: none;
              }
            }
          }
          .week-filter {
            display: flex;
            align-items: center;
            margin-top: 10px;
            justify-content: flex-end;
            color: #8c8c8c;
            .desc {
              color: #8c8c8c;
              margin-right: 2px;
            }
            .data-select {
              width: 86px;
              height: 36px;
              ::v-deep .el-input.el-input--small.el-input--suffix {
                border: none;
              }
            }
          }
        }
      }
      p {
        color: #8c8c8c;
      }
      .day-title {
        margin-top: -5px;
      }
    }
    .card-box {
      .container {
        width: 190px;
      }
    }
  }
  .card-wrap {
    margin-left: 10px;
    //width: 180px;
    // &:nth-child(4n) {
    //   margin-right: 0;
    // }
    &:hover {
      background: #fffaed;
      border: 1px solid #ffc973;
    }
  }
  .card-wrap:first-child {
    margin-left: 0;
  }

  .active-card {
    background: #fffaed;
  }
  .btn-more-map {
    color: $--color-primary;
    width: 130px;
    height: 36px;
    font-size: 16px;
    border-radius: 18px;
    border: 1px solid #ffc973;
    background: #fffaed;
    cursor: pointer;
    text-align: center;
    line-height: 36px;
  }
}
.img-no-data {
  margin-top: 20px;
  text-align: center;
  background: url('../../assets/images/img_bg_charts_no_data.png') no-repeat;
  height: 218px;
  img {
    margin-top: -30px;
    width: 160px;
    height: 160px;
  }
  p {
    font-size: 16px;
    color: #8c8c8c;
  }
}
.img-map-no-data {
  text-align: center;
  img {
    width: 160px;
    height: 160px;
  }
  p {
    font-size: 16px;
    color: #8c8c8c;
  }
}
.complex-wrap {
  min-height: 574px;
  .card-box {
    .title {
      margin-bottom: 10px;
      font-size: 16px;
    }
    img.icon-help {
      height: 10px;
      width: 10px;
      margin-left: 3px;
    }
  }
}
.mask {
  position: relative;
}
</style>
